import { render, staticRenderFns } from "./dataSummaryScreen.vue?vue&type=template&id=4bdeab8a&scoped=true&"
import script from "./dataSummaryScreen.vue?vue&type=script&lang=js&"
export * from "./dataSummaryScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdeab8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bdeab8a')) {
      api.createRecord('4bdeab8a', component.options)
    } else {
      api.reload('4bdeab8a', component.options)
    }
    module.hot.accept("./dataSummaryScreen.vue?vue&type=template&id=4bdeab8a&scoped=true&", function () {
      api.rerender('4bdeab8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/dataSummaryScreen.vue"
export default component.exports